module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-overview-settings__tasks"
  }, [(_vm.isInitLoad) ? _c('Loader', {
    attrs: {
      "bg-color": "#fff"
    }
  }) : [_c('div', {
    staticClass: "do-table__filters"
  }, [_c('div', {
    staticClass: "do-table__filters__left"
  }, [_c('DoFiltersFilter', {
    attrs: {
      "title": "Personer",
      "tags": _vm.persons,
      "selectedTags": _vm.selectedPersons,
      "numberOfSelectedTagsToShow": 1
    },
    on: {
      "select": _vm.onSelectPerson,
      "clear": function($event) {
        _vm.selectedPersons = []
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": "Grupper",
      "tags": _vm.tags,
      "selectedTags": _vm.selectedTags,
      "numberOfSelectedTagsToShow": 1
    },
    on: {
      "select": _vm.onSelectTags,
      "clear": function($event) {
        _vm.selectedTags = []
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": "Briktyper",
      "tags": _vm.subjectTypes,
      "selectedTags": _vm.selectedTypes,
      "numberOfSelectedTagsToShow": 1
    },
    on: {
      "select": _vm.onSelectType,
      "clear": function($event) {
        _vm.selectedTypes = []
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": "Fag/Opgaver",
      "tags": _vm.subjectNames,
      "selectedTags": _vm.selectedSubjectsNames,
      "numberOfSelectedTagsToShow": 1
    },
    on: {
      "select": _vm.onSelectSubject,
      "clear": function($event) {
        _vm.selectedSubjectsNames = []
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "do-table__filters__add"
  }, [_c('span', [_vm._v("Viser " + _vm._s(_vm.filteredSubjects.length) + " af " + _vm._s(_vm.subjects.length))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onClickAway),
      expression: "onClickAway"
    }],
    staticClass: "do-dropdown",
    class: {
      'do-dropdown--open': _vm.isDropdown
    }
  }, [(_vm.selectedSubjects.length < 1) ? _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'left',
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window'
      }),
      expression: "{\n                  placement: 'left',\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n              }"
    }],
    staticClass: "do-dropdown__toggler do-bttn do-bttn--submit do-bttn--submit--disabled",
    attrs: {
      "content": "Vælg brikker først"
    }
  }, [_vm._v("\n            Tildel " + _vm._s(!_vm.isSupplements ? 'kategori' : 'tillægstype') + " til " + _vm._s(_vm.selectedSubjects.length) + " "), _c('span', {
    staticClass: "icon-arrow-down5"
  })]) : _c('button', {
    staticClass: "do-dropdown__toggler do-bttn do-bttn--submit",
    on: {
      "click": _vm.setIsDropdown
    }
  }, [_vm._v("\n            Tildel " + _vm._s(!_vm.isSupplements ? 'kategori' : 'tillægstype') + " til " + _vm._s(_vm.selectedSubjects.length) + " "), _c('span', {
    staticClass: "icon-arrow-down5"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "do-dropdown"
    }
  }, [(_vm.isDropdown) ? _c('div', {
    staticClass: "do-dropdown__dropdown"
  }, [(!_vm.isSupplements) ? _c('ul', [(_vm.taskCategories.length === 0) ? _c('li', {
    staticClass: "text-explainer"
  }, [_vm._v("Ingen kategorier oprettet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.taskCategories), function(taskCategory, key) {
    return _c('li', {
      staticClass: "do-dropdown__dropdown__item",
      on: {
        "click": function($event) {
          return _vm.setTasksCategory(taskCategory)
        }
      }
    }, [_c('div', {
      staticClass: "do-dropdown__dropdown__item__name"
    }, [_vm._v("\n                    " + _vm._s(taskCategory.name) + "\n                  ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isSupplements) ? _c('ul', [(_vm.supplementTypes.length === 0) ? _c('li', {
    staticClass: "text-explainer"
  }, [_vm._v("Ingen tillægstyper oprettet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.supplementTypes), function(supplementType, key) {
    return _c('li', {
      staticClass: "do-dropdown__dropdown__item",
      on: {
        "click": function($event) {
          return _vm.setTasksCategory(supplementType)
        }
      }
    }, [_c('div', {
      staticClass: "do-dropdown__dropdown__item__name"
    }, [_vm._v("\n                    " + _vm._s(supplementType.title) + "\n                  ")])])
  })], 2) : _vm._e()]) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "do-table-wrapper"
  }, [_c('table', {
    staticClass: "do-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "do-table__toggle-all",
    on: {
      "click": _vm.toggleAll
    }
  }, [(_vm.selectedSubjects.length === 0) ? [_vm._v("\n              " + _vm._s(_vm.$t('vue2.tagging.select_all')) + "\n            ")] : [_vm._v("\n              Fravælg\n            ")]], 2), _vm._v(" "), _c('th', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        return _vm.sortBy('subject.name')
      }
    }
  }, [_vm._v("Titel "), (_vm.sortKey === 'subject.name') ? _c('span', [_vm._v(_vm._s(_vm.sortIcon))]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        return _vm.sortBy('calendar.name')
      }
    }
  }, [_vm._v("Person "), (_vm.sortKey === 'calendar.name') ? _c('span', [_vm._v(_vm._s(_vm.sortIcon))]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        return _vm.sortBy('subject.calendar.name')
      }
    }
  }, [_vm._v("Klasse / kalender "), (_vm.sortKey === 'subject.calendar.name') ? _c('span', {
    staticClass: "pointer"
  }, [_vm._v(_vm._s(_vm.sortIcon))]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        return _vm.sortBy('v_type')
      }
    }
  }, [_vm._v("Briktype "), (_vm.sortKey === 'v_type') ? _c('span', [_vm._v(_vm._s(_vm.sortIcon))]) : _vm._e()]), _vm._v(" "), (!_vm.isSupplements) ? _c('th', [_vm._v("Standard kategori")]) : _vm._e(), _vm._v(" "), (!_vm.isSupplements) ? _c('th', [_vm._v("Egen kategori")]) : _vm._e(), _vm._v(" "), (_vm.isSupplements) ? _c('th', [_vm._v("Tillægstype")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('virtual-list', {
    style: ({
      maxHeight: 80 + 'vh',
      overflowY: 'auto'
    }),
    attrs: {
      "estimate-size": 40,
      "keeps": 40,
      "data-key": 'id',
      "data-sources": _vm.sortedSubjects,
      "data-component": _vm.itemComponent,
      "extra-props": {
        selectedSubjectIds: _vm.selectedSubjectIds,
        selectedSubjects: _vm.selectedSubjects,
        taskCategories: _vm.taskCategories,
        toggleSubject: _vm.toggleSubject,
        updateSubjectTaskCategory: _vm.updateSubjectTaskCategory,
        isSupplements: _vm.isSupplements,
        supplementTypes: _vm.supplementTypes
      }
    }
  })], 1)])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4919a4ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TaskOverviewSettings/TaskOverviewSettingsCategoriesTasks.vue
// module id = 1623
// module chunks = 1